/* eslint-disable import/no-unused-modules */
import React from 'react';
import CountryList from '../../components/Destinations/CountryList';
import CountryMap from '../../components/Destinations/CountryMap';
import Footer from '../../components/General/Footer';
import Head from '../../components/Header/Head';
import Header from '../../components/Header/Header';
import { GET_DESTINTATIONS } from '../../helpers/graphql/locations';
import ssrGraphQLClient from '../../helpers/ssrGraphQLClient';
import withApollo from '../../lib/withApollo';

const DestinationsPage = ({ locations }) => {
  return (
    <>
      <Head
        title="Destinations"
        description="Discover the best travel destinations on TravelFeed. Explore travel experiences, insider guides and reviews for your destination."
      />
      <Header subheader="Destinations" active="destinations" />
      <CountryMap />
      <CountryList locations={locations} />
      <Footer />
    </>
  );
};

export default withApollo(DestinationsPage);

export function getStaticProps() {
  return ssrGraphQLClient(GET_DESTINTATIONS).then(({ locations }) => {
    return {
      props: { locations },
    };
  });
}
